import React from 'react';

// INTERMISSIONS
import { QuestionIntro } from '../components/profile-completion/QuestionIntro';
import { QuestionName } from '../components/profile-completion/QuestionName';
import { QuestionLocation } from '../components/profile-completion/QuestionLocation';
import { QuestionNationality } from '../components/profile-completion/QuestionNationality';
import { QuestionGender } from '../components/profile-completion/QuestionGender';
import { QuestionAge } from '../components/profile-completion/QuestionAge';
import { QuestionDegree } from '../components/profile-completion/QuestionDegree';
import { QuestionCareerLevel } from '../components/profile-completion/QuestionCareerLevel';
import { QuestionPosition } from '../components/profile-completion/QuestionPosition';
import { QuestionJobFamily } from '../components/profile-completion/QuestionJobFamily';
import { QuestionIndustry } from '../components/profile-completion/QuestionIndustry';
import { QuestionAspects } from '../components/profile-completion/QuestionAspects';
import { QuestionRequirements } from '../components/profile-completion/QuestionRequirements';
import { QuestionStartDate } from '../components/profile-completion/QuestionStartDate';
import { QuestionPicture } from '../components/profile-completion/QuestionPicture';
import { QuestionPolicy } from '../components/profile-completion/QuestionPolicy';

// OTHER COMPONENTS

// Find career level question and check whether the user is a career starter (value: 1)
const isOptionalJobQuestion = (state = {}) => {
  const { answers = {} } = state;

  // 1 - career starter
  return Boolean(answers.careerLevel?.name === 'careerLevel' && answers.careerLevel?.value === 1);
};

export const candidateProfileCompletionConfig = {
  id: 'candidateProfileCompletion',
  allowBackNavigation: true, // 0, 1, 2, 3, ..., Infinity
  modalHurryDelay: 0,
  pages: [
    // INTRO
    {
      id: 'intro',
      isIntermission: true,
      title: (
        <>
          Hallo,
          <br />
          schön dass du da bist.
          Bevor wir loslegen müssen wir dich ein wenig besser Kennenlernen.
        </>
      ),
      render: (next, prev, state, answer, handleClosePrompt, setNewAnswer, setModalCancelShow) => (
        <QuestionIntro
          answer={answer}
          setModalCancelShow={setModalCancelShow}
          onNext={next}
        />
      ),
    },
    // NAME
    {
      id: 'username',
      noPrev: true,
      title: 'cp_name_question',
      Component: QuestionName,
    },
    // LOCATION
    {
      id: 'location',
      title: 'cp_residence_question',
      Component: QuestionLocation,
    },
    // NATIONALITY
    {
      id: 'nationality',
      isOptional: true,
      title: 'cp_nationality_question',
      callout: true,
      Component: QuestionNationality,
    },
    // GENDER
    {
      id: 'gender',
      isOptional: true,
      title: 'cp_gender_question',
      callout: true,
      Component: QuestionGender,
    },
    // AGE
    {
      id: 'age',
      isOptional: true,
      title: 'cp_age_question',
      callout: true,
      Component: QuestionAge,
    },
    // DEGREE
    {
      id: 'schoolDegree',
      title: 'cp_school_degree_question',
      callout: true,
      Component: QuestionDegree,
    },
    // CAREER LEVEL
    {
      id: 'careerLevel',
      title: 'cp_careerlevel_question',
      Component: QuestionCareerLevel,
    },
    // POSITION
    {
      id: 'position',
      isOptional: isOptionalJobQuestion,
      title: 'cp_current_position_question',
      titleOptional: 'cp_current_position_question_optional',
      Component: QuestionPosition,
    },
    // JOB FAMILY
    {
      id: 'jobFamily',
      isOptional: isOptionalJobQuestion,
      title: 'cp_job_family_question',
      titleOptional: 'cp_job_family_question_optional',
      Component: QuestionJobFamily,
    },
    // INDUSTRY
    {
      id: 'experience',
      isOptional: isOptionalJobQuestion,
      title: 'cp_industry_experience_question',
      titleOptional: 'cp_industry_experience_question_optional',
      Component: QuestionIndustry,
    },
    // REQUIREMENTS
    {
      id: 'jobRequirements',
      isOptional: true,
      title: 'cp_job_requirements_question',
      Component: QuestionRequirements,
    },
    // MOTIVATION
    {
      id: 'jobMotivations',
      isOptional: true,
      title: 'cp_motivation_question',
      Component: QuestionAspects,
    },
    // START DATE
    {
      id: 'jobStartDate',
      title: 'cp_start_question',
      Component: QuestionStartDate,
    },
    // PICTURE
    {
      id: 'picture',
      isOptional: true,
      title: 'cp_image_question',
      Component: QuestionPicture,
    },
    // CONFIRM POLICY
    {
      id: 'policy',
      title: 'cp_policy',
      titleForHasExternalLegalAgreements: 'cp_policy_external',
      Component: QuestionPolicy,
    },
    // END
    {
      id: 'end',
      isIntermission: true,
      showProgressBar: true,
      render: (next, prev, state, answer, handleClosePrompt, finishable, handleFinish, errorEnd) => (
        <>
          { /* /!* ERROR END *!/ */ }
          { errorEnd }
        </>
      ),
    },
  ],
};
